<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2020-04-27 15:57:27
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2024-08-20 17:32:21
 -->
<template>
  <div class="wh100">
    <div class="head-userinfo-wrap flex justify_content_between align_items_center">
      <a href="/" class="navbar-header flex align_items_center hei100">
        <img class="logo" :src="require(`@/assets/images/logo/${language == 'en' ? 'en_' : ''}logo.png`)" />
      </a>
      <div class="flex align_items_center">
        <div :class="['menu_icon', show ? 'on' : '']"  @click="showRightSlip()">
          <div class="menuline line1"></div>
          <div class="menuline line2"></div>
          <div class="menuline line3"></div>
        </div>
      </div>
    </div>
    <RightSlip ref="rightSlip" @rightSlipList="rightSlipList" :list="list" :select="select" :visible="show" />
  </div>
</template>
<script>
import path from 'path'
import { mapGetters } from 'vuex'
import { deepClone } from '@/utils'
import RightSlip from '@/components/m/RightSlip'
export default {
  name: 'headMenu',
  props: {
    defaultActive: {
      type: String
    },
    scroll: {
      type: Number
    }
  },
  components: {
    RightSlip
  },
  data () {
    return {
      showMenu: [],
      list: [],
      select: 0,
      show: false
    }
  },
  computed: {
    ...mapGetters([
      'permission_routes',
      'language'
    ]),
    activeMenu () {
      const route = this.$route
      const { meta, path } = route
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    }
  },
  watch: {
    '$route' (newV, oldV) {
      this.getMenuList()
    }
  },
  created () {
    this.getMenuList()
  },
  methods: {
    getMenuList () {
      const menuArr = []
      const menus = deepClone(this.permission_routes)
      menus.forEach((item, index) => {
        if (item.children) {
          item.children.forEach(($item, $index) => {
            if ($item.meta.show && !$item.meta.header) {
              $item.path = path.resolve(item.path, $item.path)
              if ($item.path.indexOf('/about') !== -1) {
                $item.meta.title = $item.title
              }
              $item.children && $item.children.forEach(($list) => {
                if ($list.meta.show) {
                  $list.path = path.resolve(item.path, $item.path, $list.path)
                }
              })
              if ($item.path === '/cooperate') {
                $item.children.forEach(($list, $i) => {
                  if ($list.meta.show && !$list.meta.header) {
                    // $item.meta.title = $list.meta.title
                    // $item.children = $list
                    // $item.path = $list.meta.checked
                    $item = $list
                    $item.path = $list.meta.checked
                  }
                })
              }
              // if ($item.path === '/innovative' && this.language === 'zh') {
              if ($item.path === '/innovative' || $item.path === '/en/innovative') {
                $item.children = this.getInnovativeRoutes($item.children)
                console.log($item.children)
              }
              menuArr.push($item)
            }
          })
        }
      })
      this.showMenu = menuArr
      this.list = menuArr
    },
    // 显示右滑组件
    showRightSlip () {
      this.show = !this.show
      if (this.show) {
        this.$refs.rightSlip.show()
      } else {
        this.$refs.rightSlip.close()
      }
    },
    // 右滑组件列表点击事件
    rightSlipList (_path) {
      this.show = false
      if (_path === this.$route.path) {
        this.$router.go(0)
      } else {
        this.$router.push(_path)
      }
    },
    // getInnovativeRoutes (arr) {
    //   const innovative = []
    //   arr.forEach((item, index) => {
    //     if (item.meta.type.classHead) {
    //       innovative.push(item)
    //     }
    //   })
    //   return innovative
    // }
    getInnovativeRoutes (arr) {
      const innovative = []
      arr.forEach((item, index) => {
        if (item.meta.type.classHead) {
          innovative.push({ path: item.meta.checked, title: item.meta.title, meta: { checked: item.meta.checked }, type: item.meta.type.classify, children: {} })
        } else {
          const _index = innovative.findIndex($item => $item.type === item.meta.type.classify)
          if (_index !== -1) {
            const item1 = innovative[_index]
            if (item1.children[item.meta.type.name]) {
              item1.children[item.meta.type.name].list.push({
                title: item.meta.title,
                path: item.meta.checked,
                meta: { checked: item.meta.checked },
                hot: item.meta.hot
              })
            } else {
              item1.children[item.meta.type.name] = {
                title: item.meta.type.title,
                name: item.meta.type.name,
                list: [{ path: item.meta.checked, title: item.meta.title, hot: item.meta.hot }]
              }
            }
          }
        }
      })
      return innovative
    }
  }
}
</script>

<style lang="less">
.toastWarning{
    color:#e7a23d;
}
.head-userinfo-wrap{
  height: 100%;
  padding-left: 30px;
  color: #ffffff;
  position: relative;
  z-index: 999;
  .navbar-header{
      .logo{
          height: 42px;
      }
  }
  .language_icon{
    font-size: 44px;
    padding: 0 25px 0 10px;
  }
  .menu_icon {
    padding-right: 30px;
    width: 70px;
    height: 100px;
    position: relative;
    .menuline {
      display: inline-block;
      width: 40px;
      height: 4px;
      border-radius: 3px;
      background-color: #ffffff;
      border-radius: 3px;
      position: absolute;
      transition: all 0.2s ease;
      -ms-transition: all 0.2s ease;
      -moz-transition: all 0.2s ease;
      -webkit-transition: all 0.2s ease;
      -o-transition: all 0.2s ease;
      transform-origin: right;
      -ms-transform-origin: right;
      -moz-transform-origin: right;
      -webkit-transform-origin: right;
      -o-transform-origin: right;
      &.line1 {
        top: 36px;
      }
      &.line2 {  //前一条线
        top: 48px;
      }
      &.line3 {  //后一条线
        top: 60px;
      }
    }
    &.on {
      .line1 {
        transform: translateY(-5px) rotate(-45deg);
        -ms-transform: translateY(-5px) rotate(-45deg);
        -moz-transform: translateY(-5px) rotate(-45deg);
        -webkit-transform: translateY(-5px) rotate(-45deg);
        -o-transform: translateY(-5px) rotate(-45deg);
      }
      .line2 {
        opacity: 0;
      }
      .line3 {
        transform: translateY(0px) rotate(45deg);   //中间的线顺时针旋转45°
        -ms-transform: translateY(0px) rotate(45deg);
        -moz-transform: translateY(0px) rotate(45deg);
        -webkit-transform: translateY(0px) rotate(45deg);
        -o-transform: translateY(0px) rotate(45deg);
      }
    }
  }
}
</style>
